import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/rootReducer';

const initialState = {
  chat: {
    messages: [],
  },
};

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
});